import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["card"]
  static classes = ["active", "highlight"]

  // 一覧⇄詳細遷移直後、対象カードが画面中央に来るようスクロールする
  // 一覧ページ側はTurbo自身のアンカースクロール（URLの#idへの先頭合わせ）が
  // 後から発火してこの中央合わせを上書きしてしまうため、turbo:load完了を待つ
  connect() {
    document.addEventListener("turbo:load", this.scrollToTargetCard, { once: true })
  }

  disconnect() {
    document.removeEventListener("turbo:load", this.scrollToTargetCard)
  }

  // 非表示要素へのscrollIntoViewはno-opなので、対象カードが無い画面幅では何も起きない
  scrollToTargetCard = () => {
    const card = this.findTargetCard()
    card?.scrollIntoView({ block: "center" })

    // 一覧に戻った際、見ていたカードだと分かるよう枠を一瞬太くする（消えるタイミングはCSSアニメーション側で制御）
    // Turboが自前のアンカースクロール後にURLのハッシュを書き換えてしまうため、:targetでは狙えずクラス付与が必要
    if (this.hasHighlightClass) card?.classList.add(this.highlightClass)
  }

  // 詳細ページの左カラム: 表示中のカード（activeクラス）
  // 一覧ページ: 詳細から戻ってきた際に見ていたカード（URLアンカー）
  findTargetCard() {
    return (this.hasActiveClass && this.cardTargets.find(c => c.classList.contains(this.activeClass)))
      || document.getElementById(decodeURIComponent(location.hash.slice(1)))
  }

  activate(event) {
    const id = String(event.params.identifier)
    this.cardTargets.forEach(c => {
      c.classList.toggle(this.activeClass, c.dataset.cardIdentifier === id)
    })
  }
}
